import request from './../../utilities/request';
import localStorageToken from './../../utilities/storage';

function get(page) {
  return request({
    url:    `/featured/list/page/${ page }`,
    headers: {'Authorization': localStorageToken()},
    method: 'GET'
  });
}

function create(values) {
  return request({
    url:    '/featured/save',
    headers: {'Authorization': localStorageToken()},
    method: 'POST',
    data:   values
  });
}

function update(id, values) {
  return request({
    url:    `/featured/update/${ id }`,
    headers: {'Authorization': localStorageToken()},
    method: 'PUT',
    data:   values
  });
}

function find(id) {
  return request({
    url:    `/featured/overview/${ id }`,
    headers: {'Authorization': localStorageToken()},
    method: 'GET'
  });
}

function remove(id) {
  return request({
    url:    `/featured/remove/${ id }`,
    headers: {'Authorization': localStorageToken()},
    method: 'DELETE'
  });
}

const FeaService = {
  get, create, update, remove, find
}

export default FeaService;
